// src/i18n/shell.ts —— 06 admin-console C-01 / C-01b / C-24 / 全局约定 G-10 / Toast 映射；06 未给英文或未给键的标「本计划定稿」（待回写 06）
export const I18N_ADMIN_SHELL = {
  zh: {
    // 2026-10-15 空闲自动退出 / 最长在线（06 C-01 会话保持）
    idleTitle: '仍在使用吗？',
    idleWarn: '即将因长时间未操作自动退出（倒计时 {n} 秒）',
    idleContinue: '继续使用',
    idleLoggedOut: '因长时间未操作，已自动退出',
    sessionMaxAge: '登录已超过 {n} 小时，请重新登录',
    sessionExpired: '登录已失效，请重新登录',
 cryptoPayments:'USDT收付',hCryptoPayments:'固定地址、链上实收及异常双人复核',
    cardSecret: '卡面明文查看', // 2026-10-17 权限矩阵模块（仅 view 位）：后台「显示卡号」
    profit: '利润台账', // 0047：菜单页名与权限矩阵模块同键（仅 view / export 位，06 C-32）
    hProfit: '收入、分润、已知成本与平台净利润（按来源单据逐笔入账）', // 06 C-32 页头副题
    broadcast: '广告推送', // 0049：菜单页名与权限矩阵模块同键（view / edit / approve / export，06 C-33）
    hBroadcast: '经 Bot 向私聊过的用户群发推广消息：排期、审核与送达明细', // 06 C-33 页头副题
    // C-01b 首登向导
    onbStep1: '修改密码',
    onbStep2: '绑定 2FA',
    onbTitle: '完成安全设置',
    onbSub: '首次登录需修改初始密码并绑定动态验证码后才能进入后台。',
    onbNext: '下一步',
    onbTotpTip: '用 Google Authenticator / 1Password 等扫码或手动输入秘钥',
    onbDone: '完成绑定',
    onbPwdPh: '8-20 位，含字母与数字', // 06 C-01b 新密码 placeholder；键名本计划定稿
    onbCopy: '复制', // 06 C-01b「复制」按钮；键名本计划定稿
    onbSecret: '秘钥', // 本计划定稿（秘钥行标签）
    toastOnboardDone: '安全设置已完成，请使用新密码与动态验证码重新登录',
    toastCopied: '已复制',
    errOldPwd: '当前密码错误',
    errPwdRule: '新密码至少 8 位且需包含字母与数字，两次输入需一致',
    // G-10 权限显隐
    noPermAny: '当前账号未分配任何模块权限，请联系超级管理员',
    noPermHint: '无权限：需要「{module}·{bit}」权限',
    toastNoPerm: '无权限执行该操作',
    permApprove: '审核', // G-10 第 2 条 noPermHint 位名「{编辑|审核}」；键名本计划定稿
    permEdit: '编辑', // 同上（位名与按钮文案分键，en 小写与 permApprove 同口径）
    // C-24 新增页名与页头副题
    treasury: '金库归集',
    alerts: '告警',
    budgets: '预算池',
    cardActions: '卡操作单',
    upstreamCosts: '成本台账',
    hTreasury: '链上归集登记与平台负债视图',
    hAlerts: '系统告警：去重计数、确认处理',
    hBudgets: '每个上游卡组一个预算：注资、分配与余量', // 本计划定稿（取 06 C-27 口径段）
    hCardActions: '待复核单（暂扣 / 释放超阈值、上游发起的销卡）与待对账单', // 本计划定稿（取 06 C-29 首段）
    hUpstreamCosts: '按上游商户钱包流水同步的成本记录（只读）', // 本计划定稿（取 06 C-30 首段）
    // C-24 上游状态章
    upstreamDown: '上游异常',
    upstreamWarn: '上游波动',
    // 未就绪端点（D8-8 搭壳动作、CSV 未就绪与下钻桩共用）
    featurePending: '该功能即将开放', // 本计划定稿
    // 1303 超限代理列表（06 C-13 / C-14）
    // [改写 key]
    audit: '操作记录', // 06 C-23
    toastMyPwd: '密码已修改，请重新登录', // 06 Toast 映射（S-86 含当前会话失效）
  },
  en: {
    idleTitle: 'Still there?',
    idleWarn: 'You will be signed out soon due to inactivity ({n}s left)',
    idleContinue: 'Stay signed in',
    idleLoggedOut: 'You were signed out due to inactivity',
    sessionMaxAge: 'You have been signed in for more than {n} hours. Please sign in again.',
    sessionExpired: 'Your session has expired. Please sign in again.',
 cryptoPayments:'USDT payments',hCryptoPayments:'Address pools, receipts and independent remedy reviews',
    cardSecret: 'Card number reveal', // 2026-10-17 matrix module (view bit only)
    profit: 'Profit Ledger', // 0047 page & matrix module (view / export bits only)
    hProfit: 'Revenue, partner shares, known costs and net platform profit, per source document',
    broadcast: 'Bot Broadcasts', // 0049 page & matrix module (view / edit / approve / export)
    hBroadcast: 'Promotional messages to users who chatted with your bots: scheduling, review and delivery details',
    onbStep1: 'Change password', // 本计划定稿
    onbStep2: 'Bind 2FA', // 本计划定稿
    onbTitle: 'Finish security setup',
    onbSub: 'Change your initial password and bind a one-time code before entering the console.', // 本计划定稿
    onbNext: 'Next', // 本计划定稿
    onbTotpTip: 'Scan with Google Authenticator / 1Password, or enter the secret manually', // 本计划定稿
    onbDone: 'Finish binding', // 本计划定稿
    onbPwdPh: '8-20 characters, letters and digits', // 本计划定稿
    onbCopy: 'Copy', // 本计划定稿
    onbSecret: 'Secret', // 本计划定稿
    toastOnboardDone: 'Security setup complete — sign in again',
    toastCopied: 'Copied', // 本计划定稿
    errOldPwd: 'Current password is incorrect', // 本计划定稿
    errPwdRule: 'New password must be at least 8 characters with letters and digits, and both entries must match', // 本计划定稿
    noPermAny: 'No module is granted to this account. Contact a super admin.',
    noPermHint: 'No permission: requires {module} · {bit}',
    toastNoPerm: "You don't have permission for this action",
    permApprove: 'approve', // 本计划定稿
    permEdit: 'edit', // 本计划定稿
    treasury: 'Treasury',
    alerts: 'Alerts',
    budgets: 'Budgets',
    cardActions: 'Card operations',
    upstreamCosts: 'Upstream costs',
    hTreasury: 'On-chain sweep records and platform liabilities',
    hAlerts: 'System alerts: deduplicated, acknowledge to clear',
    hBudgets: 'One budget per upstream card group: funding, allocation and surplus', // 本计划定稿
    hCardActions: 'Review queue (over-threshold hold / release, upstream-initiated closes) and unknown-state reconciliation', // 本计划定稿
    hUpstreamCosts: 'Cost entries synced from the upstream merchant wallet (read-only)', // 本计划定稿
    upstreamDown: 'Upstream down',
    upstreamWarn: 'Upstream degraded',
    featurePending: 'Coming soon', // 本计划定稿
    audit: 'Operation log',
    toastMyPwd: 'Password changed — please sign in again',
  },
} as const;

// TD-805：与原型字典重名的键须显式登记才覆盖原型值（06 [改写 key]）
export const REWRITES_ADMIN_SHELL: readonly string[] = ['audit', 'toastMyPwd'];
